import Layout from "Components/Layout/Layout";
import Imports from "Pages/Imports/Imports";

export default function LeaseplanImport() {
	return (
		<Layout title="Leaseplan Fahrzeuge importieren">
			<Imports importType="LeaseplanVehicleImport" />
		</Layout>
	);
}
